export default __webpack_public_path__ + "images/92f3b197a52711b6a4372fd77566a530.svg";